
import http from './http/http'
/**
 * 接口名字:{http:'域名变量，可以不写',
 * 			url:'...域名意外的访问路基ing',
 *          istoken: true或者false,
 * 			page:true 或者false
 * 			desc: '描述文字 放参数名字'}
 * 会员信息: { url: '/member/info', istoken: true, desc: '' },
 * 图片上传1: {http:'root_upload', url: '/upload/send', istoken: true, desc: '{uploadId:""} ' },
 */
const interfaceNameObj = {
  轮播图接口: { url: '/picture/list', istoken: false, desc: ''},
  期刊列表:{ url: '/qikan/list', istoken: false, desc: ''},
  新闻公告动态:{ url: '/content/list', istoken: false, desc: ''},
  图书列表:{url:'/book/list', istoken: false, desc: ''},
  新闻公告详情:{ url: '/content/info', istoken: false, desc: ''},
  图书详情:{url:'/book/info', istoken: false, desc: ''},
  添加浏览记录:{url:'/history/add',istoken: false, desc: ''},
  浏览记录:{url:'/history/viewlist',istoken: false, desc: ''},
  侧面导航列表:{url:'/column/list',istoken: false, desc: ''},
  图书排行:{url:'/book/sortList',istoken: false, desc: ''},
  图书检索:{url:'/book/searchList',istoken: false, desc: ''},
  分类详情:{url:'/column/info',istoken: false, desc: ''},
  书目下载列表:{url:'/book/loadList',istoken: false, desc: ''},
  PDF文档推荐:{url:'/exchange/list',istoken: false, desc: ''},
  PDF排行榜:{url:'exchange/sortList',istoken: false, desc: ''},
  PDF文档检索:{url:'exchange/searchList',istoken: false, desc: ''},
}




var Vue = null

const API = {
  async API_Ajax (interfaceName, data) {
    const urlData = interfaceNameObj[interfaceName]
    if (!urlData || urlData.url === '') { return { mess: '不存在此接口，请检查后再调用' } }
    var index = 0
    Object.keys(interfaceNameObj).forEach((item, i) => {
      if (item == interfaceName) {
        index = i
      }
    })
    return await http.post(urlData ,data, index)
  },
  async API_AjaxGet (interfaceName, data) {
    const urlData = interfaceNameObj[interfaceName]
    if (!urlData || urlData.url === '') { return { mess: '不存在此接口，请检查后再调用' } }
    var index = 0
    Object.keys(interfaceNameObj).forEach((item, i) => {
      if (item == interfaceName) {
        index = i
      }
    })
    return await http.get(urlData ,data, index)
  },
  async API_Form (interfaceName, data) {
    debugger
    const urlData = interfaceNameObj[interfaceName]
    if (!urlData || urlData.url === '') { return { mess: '不存在此接口，请检查后再调用' } }
    var index = 0
    Object.keys(interfaceNameObj).forEach((item, i) => {
      if (item == interfaceName) {
        index = i
      }
    })
    return await http.postForm(urlData ,data, index)
  }
}

class HttpHelp {
  // constructor () { }
  static install (vue, option) {
    Vue = vue
    let that = this
    Vue.mixin({
      beforeCreate () {
        window.$API = API
        window.$interfaceName = interfaceNameObj
        Vue.prototype.$API = API
      }
    })
  }
}
export default HttpHelp
 